export function reloadPage() {
  window.location.reload();
}
